var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:['asc-link-button', _vm.disabled ? 'asc-link-button--disabled' : null],attrs:{"text":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('asc-label',{class:[
      'asc-link-button--label',
      {
        'asc-link-button--label-hover': _vm.hover,
        'asc-link-button--label-uppercase': _vm.uppercase,
      } ],attrs:{"value":_vm.text,"uppercase":_vm.uppercase,"prepend-icon":_vm.prependIcon,"append-icon":_vm.appendIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }